import HistoricalFitnessProfiles from "@/components/FitnessProfile/HistoricalProfiles/HistoricalFitnessProfiles";

const HistoricalFitnessProfilesPage: React.FC = () => {
  return <HistoricalFitnessProfiles />;
};

export default HistoricalFitnessProfilesPage;
